import(/* webpackMode: "eager" */ "/home/ubuntu/download/69c107907d947e00146e8931/netopsai/src/app/network-operations-dashboard/page.tsx");
